import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AppSharedModule } from '../../../../../../../app-shared.module';
import { BaseSectionComponent } from '../base-section';

@Component({
  selector: 'app-conversational-section',
  imports: [AppSharedModule],
  templateUrl: './conversational-section.component.html',
  styleUrl: './conversational-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationalSectionComponent extends BaseSectionComponent {
  colorIndex = input<number>(0);
}
